import { HttpImportRepository } from "@data/repositories/index";
import { GetImportHistoryUseCase } from "@useCases/index";
import { api } from "@data/api";

export default function useImportHistory() {
  const getImportHistory = async () => {
    const useCase = new GetImportHistoryUseCase(new HttpImportRepository(api));

    return useCase.execute();
  };
  return {
    getImportHistory,
  };
}
